/**
 * Advanced Form Controls & Input's
 */

$(document).on("ready", function () {
    // Currency
    $(".budget .currency-decimal").autoNumeric("init", {
        aSign: "$",
        mDec: 2,
        currencySymbolPlacement: "p",
        vMin: -9999999,
    });

    $('.budget .currency-decimal').on('change',function(){
        var $input=$(this);
        console.log($input);
        if($input.hasClass('income')) {
            var _type='income';
            var _anti_type='expense';
        }else if($input.hasClass('expense')) {
            var _type='expense';
            var _anti_type='income';
        }

        if($input.hasClass('estimate')) {
            var _cat='estimate';
            var _anti_cat='actual';
        }else if($input.hasClass('actual')) {
            var _cat='actual';
            var _anti_cat='estimate';
        }

        let sum=0;
        $('input.currency-decimal.'+ _cat+'.'+ _type).each(function(){
            let val=parseFloat( $(this).val().replace('$', '').replace(/,/g, '') );
            console.log(val);
            if (!isNaN(val)) {
                sum += val;
            }
        });
        let sum_float=sum=parseFloat(sum);
        let anti_sum=parseFloat($('.sum td.' + _anti_type + '.' + _cat).text().replace('$', '').replace(/,/g, '') );

        let formatted_currency=sum.toLocaleString( 'en-US', {
            style: 'currency',
            currency: 'USD',
            // Options below are optional as they are defaults for currency
            minimumFractionDigits: 2, // Default for USD
            maximumFractionDigits: 2, // Default for USD
        } );
        let formatted_sum=sum_float.toFixed(2);
        $('td.' + _cat + '.' +_type).text(formatted_currency );
        $('input.hidden.' + _cat + '.' +_type).val(formatted_sum);
        if(_type=='income'){
            var new_total = sum - anti_sum;
        }else{
            var new_total = anti_sum - sum;
        }
        let new_total_float=new_total;
        $('td.total.'+ _cat).text(new_total.toLocaleString( 'en-US', {
            style: 'currency',
            currency: 'USD',
            // Options below are optional as they are defaults for currency
            minimumFractionDigits: 2, // Default for USD
            maximumFractionDigits: 2, // Default for USD
        } ) );
        $('input.hidden.total.' + _cat).val(new_total_float.toFixed(2));
    });

    $('.my-budget .save-budget').on('click',function(e){
        e.preventDefault();
        var $this=$(this);
        $this.addClass('disabled').attr('disabled',true).text('Saving...');
        $.ajax({
            type: "POST",
            url: '/wp-admin/admin-ajax.php',
            data: $(this).closest('form').serialize(),
            success: function (data) {
                console.log('hi');
                $this.removeClass('disabled').attr('disabled',false).text('Save My Budget');
            },
            error: function (data) {
                console.log(data);
            },
        });
    });
});
